import styles from "../Profile/Profile.module.css";
import useProfileGallery from "../../hooks/useProfileGallery";
import { useUserAuth } from "../../context/UserAuthContext";
import { getSingleProfieFile } from "../../context/apiCalls/apiCalls";
import Context from "../../context/Context";
import ProfilePopup from "./ProfilePopup";
import Play from "../../../src/assests/play.svg";
import Bluearrow from "../../assests/blueArrow.png";
import noEntryIcon from "../../assests/noEntryIcon.svg";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Loading from "../Loading/Loading";
import WhatsAppButton from "../WhatsAppButton/WhatsAppButton";
import { isEmpty } from "lodash";

function ProfileGrid({ data }) {
  const { verifyUser, userIdToken, isMobile } = useContext(Context);
  const [pageNumber, setPageNumber] = useState(1);
  const { currentUser } = useUserAuth();
  const token = userIdToken || currentUser?.accessToken;
  const [showPreview, setShowPreview] = useState(false);
  const [singleFileDetails, setSingleFileDetails] = useState({});
  const [singleFileLoading, setSingleFileLoading] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [userId, setUserId] = useState();
  useEffect(() => {
    const userIdLocal = localStorage.getItem("userId")
      ? localStorage.getItem("userId")
      : "data?.userId";
    setUserId(userIdLocal);
  }, [data?.userId]);
  useEffect(() => {
    verifyUser();
  }, []);
  const { dataloading, error, profileContent, hasMore } = useProfileGallery(
    pageNumber,
    token,
    viewMore
  );
  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (dataloading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [dataloading, hasMore, viewMore]
  );
  const handleFileClick = async (obj) => {
    setSingleFileLoading(true);
    setSingleFileDetails([]);
    setShowPreview(true);
    const data = await getSingleProfieFile(
      obj.campaignId,
      obj.contestId,
      obj.videoId,
      token,
      obj.orgId
    );
    setSingleFileDetails(data);
    setSingleFileLoading(false);
  };
  const handleViewAllEntries = () => {
    setPageNumber(2);
    setViewMore(true);
  };
  const WhatsAppMessage = `Hello Team Goviral, I would like to receive your WhatsApp notifications and that will greatly enhance my engagement and ensure that I don't miss out on any opportunities. Your messageId:GVUS${userId}`;

  return (
    <>
      {/* <div className="p-[20px]">
        <p className="text-large-medium ">My Entries</p>
      </div> */}

      <div className={styles.grid}>
        {!dataloading && isEmpty(profileContent) ? (
          <>
            <div className="w-[100%] pt-[40px] pb-[60px] flex flex-col items-center gap-[10px] text-center">
              <img src={noEntryIcon} />
              <p className="text-regular-medium">
                You haven't participated yet
              </p>
              <p className="text-small text-[#cdcdcd]">
                All of your participation will be
                <br /> displayed here.
              </p>
            </div>
          </>
        ) : (
          <>
            <div className={styles.pureGrid}>
              {profileContent?.map((obj, indexnumber) => {
                if (profileContent?.length === indexnumber + 1) {
                  return (
                    <div
                      onClick={() => handleFileClick(obj)}
                      ref={lastElementRef}
                      key={obj._id}
                    >
                      <div className="relative">
                        <img
                          className={styles.gridingg}
                          src={
                            obj.thumbnailUrl
                              ? obj.thumbnailUrl
                              : obj?.fileUrls[0]?.fileUrl
                          }
                          alt=""
                        />
                        {obj?.fileType === "video" && (
                          <img className={styles.playbtn} src={Play} alt="" />
                        )}
                        {obj?.status == "EDITED" && (
                          <div className={styles.filter}>
                            <p className="text-smallest">Under Review</p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div onClick={() => handleFileClick(obj)}>
                      <div className="relative">
                        <img
                          className={styles.gridingg}
                          src={
                            obj.thumbnailUrl
                              ? obj.thumbnailUrl
                              : obj?.fileUrls[0]?.fileUrl
                          }
                          alt=""
                        />
                        {obj?.fileType === "video" && (
                          <img className={styles.playbtn} src={Play} alt="" />
                        )}
                        {obj?.status == "EDITED" && (
                          <div className={styles.filter}>
                            <p className="text-smallest">Under Review</p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              })}
            </div>
            {dataloading && <Loading />}
          </>
        )}
      </div>
      <div className="px-[20px] ">
        {!viewMore &&
          profileContent &&
          !dataloading &&
          profileContent.length !== 0 && (
            <div
              className="w-[100%]  text-center  mt-[20px] py-[11px] commonButton text-[#0F6ABE]"
              style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
              onClick={handleViewAllEntries}
            >
              <p className="text-[13px] text-[#0F6ABE]">View All Entries</p>{" "}
              <img className=" inline-block" src={Bluearrow} alt="" />
            </div>
          )}
      </div>
      {/* {!isMobile && (
        <>
          <div className="p-[20px]">
            <div className="seperator" />
          </div>
          <div className="w-[100%] py-[32px] px-[40px] text-center flex flex-col items-center gap-[16px]">
            <p className="text-regular text-[#cdcdcd]">
              Would you prefer to receive all contest notifications through
              WhatsApp?
            </p>
            <WhatsAppButton
              phoneNumber="+918618406454"
              message={WhatsAppMessage}
            />
          </div>
        </>
      )} */}
      {showPreview && (
        <ProfilePopup
          setShowPreview={setShowPreview}
          singleFileDetails={singleFileDetails}
          token={token}
          profileContent={profileContent}
          singleFileLoading={singleFileLoading}
          setSingleFileDetails={setSingleFileDetails}
        />
      )}
    </>
  );
}

export default ProfileGrid;
